export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            class_route: classRoute(entity),
        };
    }

    async function get(classSlug) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('classes').get('classes/' + classSlug);
            item = build(data.class);
        } catch (e) {
            error = useApiError(e);
        }
        return {item, error};
    }

    function classRoute(entity) {
        if (!entity.class_slug) return undefined;
        return {
            name: 'classes-classSlug',
            params: {
                classSlug: entity.class_slug,
            },
        };
    }

    return {build, get};
}
